import styled from 'styled-components'
import { Button } from '@pancakeswap/uikit'

interface NumTicketsToBuyButtonProps {
  onClick: () => void
  disabled?: boolean
}

const StyledButton = styled(Button)`
  flex-grow: 1;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  height: 32px;
  padding: 10px 14px;
  justify-content: center;
  align-items: center; 
  border-radius: 100px; 
  font-family: Syncopate;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -0.42px;
  text-transform: uppercase; 
`

const NumTicketsToBuyButton: React.FC<React.PropsWithChildren<NumTicketsToBuyButtonProps>> = ({
  children,
  onClick,
  disabled = false,
}) => {
  return (
    <StyledButton disabled={disabled} scale="xs" mx="2px" p="4px 16px" variant="tertiary" onClick={onClick}>
      {children}
    </StyledButton>
  )
}

export default NumTicketsToBuyButton
